import { CELL_TRESHOLDS, DEFAULT_ICON_COLOR, FILLED_COLOR, getTresholdByPlaces, OVERFILLED_COLOR } from '../constants'

const { UNFILLED, FILLED, OVERFILLED } = CELL_TRESHOLDS

const computeCellRemainingPlace = (pauseQuotasCount, shiftsCount, preset, usePause = false) => {
  if (pauseQuotasCount && shiftsCount) {
    if (usePause && preset && preset.shiftPause) {
      const pausePlaces = pauseQuotasCount.details[preset.shiftPause.id] ?? 0
      const shiftPlaces = shiftsCount.details[preset.shiftPause.id] ?? 0

      return pausePlaces - shiftPlaces
    }

    return pauseQuotasCount.total - shiftsCount.total
  }

  return UNFILLED
}

const computeCellTreshold = (pauseQuotasCount, shiftsCount, preset, usePause = false) => {
  if (pauseQuotasCount && shiftsCount) {
    if (usePause && preset && preset.shiftPause) {
      const pausePlaces = pauseQuotasCount.details[preset.shiftPause.id]
      const shiftPlaces = shiftsCount.details[preset.shiftPause.id]
      const remainingPlaces = pausePlaces - shiftPlaces

      return getTresholdByPlaces(remainingPlaces)
    }

    const remainingPlaces = pauseQuotasCount.total - shiftsCount.total

    return getTresholdByPlaces(remainingPlaces)
  }

  return UNFILLED
}

const getCellStyleByTreshold = treshold => {
  if (treshold === FILLED) {
    return { color: FILLED_COLOR, fontWeight: 'bold' }
  }

  if (treshold === OVERFILLED) {
    return { color: OVERFILLED_COLOR, fontWeight: 'bold' }
  }

  return { color: DEFAULT_ICON_COLOR }
}

export {
  computeCellRemainingPlace,
  computeCellTreshold,
  getCellStyleByTreshold
}
